/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Logo from "../Assets/berlietPngBlank.png";

import {Link} from 'react-router-dom'


const NavbarProjects = () => {
  
  
  return (
    <nav>
      <div className="nav-logo-container">
        <img src={Logo} alt="" width={250} />
      </div>
      <div className="navbar-links-container">
        <a href="/" >Servicios</a>
        <a href="/" >Conozcanos</a>
        <a href="/" >Testimonios</a>
        <Link to='/projects' className='nav-links' >
                            Projectos
        </Link>
        <button className="primary-button">Contactanos ahora</button>
        
        
      </div>
      
      
    </nav>
  );
};

export default NavbarProjects;
